export const enum OrganizationManagementListMenuActions {
    CHANGE_ORGANIZATION_STATE = 'CHANGE_ORGANIZATION_STATE',
    UPLOAD_OR_PDF_TEMPLATE = 'UPLOAD_OR_PDF_TEMPLATE',
    UPLOAD_HGB_PDF_TEMPLATE = 'UPLOAD_HGB_PDF_TEMPLATE',
    RESET_OR_TO_DEFAULT_TEMPLATE = 'RESET_OR_TO_DEFAULT_TEMPLATE',
    RESET_HGB_TO_DEFAULT_TEMPLATE = 'RESET_HGB_TO_DEFAULT_TEMPLATE',
    UPLOAD_OR_EXCEL_TEMPLATE = 'UPLOAD_OR_EXCEL_TEMPLATE',
    UPLOAD_HGB_EXCEL_TEMPLATE = 'UPLOAD_HGB_EXCEL_TEMPLATE',
    RESET_OR_TO_DEFAULT_EXCEL_TEMPLATE = 'RESET_OR_TO_DEFAULT_EXCEL_TEMPLATE',
    RESET_HGB_TO_DEFAULT_EXCEL_TEMPLATE = 'RESET_HGB_TO_DEFAULT_EXCEL_TEMPLATE',
    UPLOAD_PDF_TEMPLATE = 'UPLOAD_PDF_TEMPLATE',
    RESET_TO_DEFAULT_TEMPLATE = 'RESET_TO_DEFAULT_TEMPLATE',
    CHANGE_FCP_STATE = 'CHANGE_FCP_STATE',
    ACTIVATE_CPMM = 'ACTIVATE_CPMM',
    DEACTIVATE_CPMM = 'DEACTIVATE_CPMM',
    ADD_PACKAGE = 'ADD_PACKAGE',
    SHOW_PACKAGES = 'SHOW_PACKAGES',
}
